import React from "react"
import { Link } from "react-router-dom"
import { FaWater, FaWrench, FaLeaf } from "react-icons/fa"
import logo from "../assets/Images/LogoHeader.webp"
import images from "../utils/imageLoader"
import { featuredProjects } from "../data/projects"

const services = [
  { icon: <FaWater className="text-primary" size={28} aria-hidden="true" />, title: "Distribución de Agua", description: "Garantizamos continuidad operativa para la distribución de agua potable." },
  { icon: <FaWrench className="text-primary" size={28} aria-hidden="true" />, title: "Mantenimiento de Redes", description: "Realizamos mantenimiento preventivo y correctivo de la red de acueducto." },
  { icon: <FaLeaf className="text-primary" size={28} aria-hidden="true" />, title: "Acompañamiento Técnico", description: "Brindamos orientación sobre uso responsable del agua y buenas prácticas." },
]

const HomePage = () => (
  <div className="font-sans">
    <section className="bg-primary text-white py-14 px-6 md:py-20">
      <div className="container mx-auto max-w-5xl text-center">
        <img src={logo} alt="Logo de Servipúblicos E.S.P." className="h-16 md:h-20 mx-auto mb-6" />
        <h1 className="text-3xl md:text-5xl font-bold">Servipúblicos E.S.P.</h1>
        <p className="mt-3 text-base md:text-lg">NIT 821000380-2</p>
        <p className="mt-4 text-sm md:text-base text-blue-100 max-w-3xl mx-auto">Entidad prestadora de servicios públicos, comprometida con la gestión responsable y la atención a la comunidad.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/services" className="bg-accent text-primary font-semibold py-3 px-6 rounded-md">Ver servicios</Link>
          <Link to="/contact" className="border border-blue-200 text-white font-semibold py-3 px-6 rounded-md">Contacto</Link>
        </div>
      </div>
    </section>

    <section className="bg-neutral-lightest py-10 px-6">
      <div className="container mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-primary mb-8 text-center">Nuestros Servicios</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service) => (
            <article key={service.title} className="bg-white p-6 rounded-lg shadow-md text-center h-full flex flex-col">
              <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center">{service.icon}</div>
              <h3 className="text-xl font-semibold text-secondary mb-2">{service.title}</h3>
              <p className="text-secondary-light">{service.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-10 px-6">
      <div className="container mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-primary mb-8 text-center">Proyectos Recientes</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {featuredProjects.map((project) => {
            const cover = project.images.find((img) => img.src === project.cover) || project.images[0]
            return (
              <article key={project.id} className="bg-neutral-lightest rounded-lg shadow-md text-center overflow-hidden flex flex-col">
                <img
                  src={images[project.cover]}
                  alt={cover.alt}
                  loading="lazy"
                  className="h-40 w-full object-cover"
                />
                <div className="p-5 flex flex-col flex-1">
                  <span className="inline-block self-center mb-2 px-3 py-1 text-xs font-semibold uppercase tracking-wide rounded-full bg-secondary-light text-primary">
                    {project.category}
                  </span>
                  <h3 className="text-lg font-semibold text-secondary mb-2">{project.title}</h3>
                  <p className="text-secondary-light text-sm mb-4">{project.description}</p>
                  <Link to="/projects" className="mt-auto text-primary font-semibold hover:underline">
                    Ver más evidencias →
                  </Link>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  </div>
)

export default HomePage
